import React from 'react';
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';
import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const FilterPanel = ({
    searchTerm,
    setSearchTerm,
    isAdmin,
    viewMode,
    setViewMode,
    logTypes = ['meeting', 'trust_check'],
    setLogTypes,
    // A per-app view is one app's slice of one account: neither the view
    // nor the source is the reader's to choose.
    showViewSelect = true,
    showTypeFilters = true,
}) => {
    const { t } = useTranslation('shared');

    // Toggle a source on/off, never letting the user clear the last one
    // (an empty selection would show nothing).
    const toggleType = (type) => {
        const has = logTypes.includes(type);
        if (has && logTypes.length === 1) return;
        setLogTypes(has ? logTypes.filter((x) => x !== type) : [...logTypes, type]);
    };

    return (
        <Box sx={{ mb: 3 }}>
            <Grid container spacing={2} alignItems="center">
                {isAdmin && showViewSelect && (
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel>{t('callLogs.view')}</InputLabel>
                            <Select
                                value={viewMode}
                                onChange={(e) => setViewMode(e.target.value)}
                                label={t('callLogs.view')}
                            >
                                <MenuItem value="account">{t('callLogs.accountLogs')}</MenuItem>
                                <MenuItem value="user">{t('callLogs.myLogs')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                )}
                <Grid item xs={12} md={isAdmin && showViewSelect ? 8 : 12}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder={t('callLogs.searchPlaceholder')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: 'text.secondary' }} />
                                    </InputAdornment>
                                ),
                            }}
                            size="small"
                        />
                        {searchTerm !== '' && (
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setSearchTerm('')}
                                startIcon={<CloseIcon />}
                            >
                                {t('callLogs.clear')}
                            </Button>
                        )}
                    </Box>
                </Grid>
                {showTypeFilters && (
                <Grid item xs={12}>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={logTypes.includes('meeting')}
                                    onChange={() => toggleType('meeting')}
                                />
                            }
                            label={t('callLogs.typeMeeting')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={logTypes.includes('trust_check')}
                                    onChange={() => toggleType('trust_check')}
                                />
                            }
                            label={t('callLogs.typeTrustCheck')}
                        />
                    </FormGroup>
                </Grid>
                )}
            </Grid>
        </Box>
    );
};
